import ReactTable from "../../util/ReactTable";
import AsyncBlock from "../../components/forms/AsyncBlock";
import PageTitle from "../../components/layout/PageTitle";
import PageSection from "../../components/layout/PageSection";
import Button from "../../components/forms/Button";
import PageContainerFull from "../../components/layout/PageContainerFull";
import {useCallback, useContext, useMemo} from "react";
import {FlexLayout} from "../../components/flex/Flex";
import useFetch2 from "../../hooks/useFetch2";
import {Apis} from "../../util/data";
import {useNavigate} from "react-router-dom";
import {format} from "date-fns";
import * as React from "react";
import {AuthContext} from "../../context/AuthContext";
import useEditModal from "../../modals/useEditModal";
import GenericModal2 from "../../modals/GenericModal2";
import CancelCita from "../../components/CancelCita";

const CitaList = () => {

  const navigate = useNavigate()
  const {user} = useContext(AuthContext)
  const {loading, data, fetchData, error} = useFetch2(Apis.PROD + '/cita-consejeria/list' + ((user?.tipoUsuario === 6) ? "/" + user?.id: ""), []);

  const formatoFecha = 'dd/MM/yyyy HH:mm:ss';

  const {wrapper: wrapper1, editAction} = useEditModal({
    editComponent: <CancelCita />,
    onRefresh: fetchData
  });

  function editCita(item) {
    navigate('/citas/edit/' + item.id + '/' + item.idConsejeria)
  }

  const fechaValue = useCallback(cell => {
    return cell.renderValue() ? format(new Date(cell.renderValue()), formatoFecha) : ''
  }, []);

  const actionsValue = useCallback(cell =>
      <FlexLayout justifyContent='space-around'>
        { user?.tipoUsuario !== 6 && (new Date(cell.row.original.fecha) > new Date()) &&
        <div>
          {cell.row.original.cancelado !== "Cancelado" && <Button style={{marginRight: 8}} size='xs' variant='light' onClick={() => editCita(cell.row.original)}>Mover cita</Button>}
          {cell.row.original.cancelado !== "Cancelado"  && <Button size='xs' variant='danger' onClick={() => editAction({
            id: cell.row.original.id
          })}>Cancelar</Button>}
        </div>
        }
      </FlexLayout>
    // eslint-disable-next-line react-hooks/exhaustive-deps
    , [user]);

  const columns = useMemo(
    () => [
      {
        header: 'Consejeria',
        accessorKey: 'consejeria'
      },
      {
        header: 'Cliente',
        accessorKey: 'cliente',
      },
      {
        header: 'Consejero',
        accessorKey: 'consejero',
      },
      {
        header: 'Precio',
        accessorKey: 'precio',
      },
      {
        header: 'Fecha de la cita',
        accessorKey: 'fecha',
        cell: fechaValue
      },
      {
        header: 'Fecha que se reservo',
        accessorKey: 'fechaReserva',
        cell: fechaValue
      },
      {
        header: 'Cancelado',
        accessorKey: 'cancelado',
      },
      {
        header: 'Fecha cancelado',
        accessorKey: 'fechaCancel',
        cell: fechaValue
      },
      {
        header: 'Acciones',
        accessorKey: 'id',
        meta: {
          headerClassName: 'text-center', // class para la cabecera
          columnClassName: 'text-center', // class para la columna
        },
        enableSorting: false, // para deshabilitar el sort
        cell: actionsValue
      }
    ]
    // eslint-disable-next-line react-hooks/exhaustive-deps
    , [data]
  )

  return (
    <PageContainerFull>

      <PageSection>
        <PageTitle title={'Citas'}/>

        <AsyncBlock loading={loading} error={error}>
          <ReactTable
            columns={columns}
            data={data || []}
            customSearch
            noData='No existen citas'
            pageSize={20}
          />
        </AsyncBlock>
      </PageSection>
      <GenericModal2 {...wrapper1} />
    </PageContainerFull>
  )
}

export default CitaList
